import Step4 from './Step4';

export default {
  title: 'Ecological Conditions',
  component: Step4,
};
